export class MobileStatus {
	mobileStatus : boolean; 
}